import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import {GroupedOutletCustomSearchModel} from "../grouped-outlet-custom-search.model";
import {AuthService, provideSearchModel} from "@fedeltapointofsale/data-client";
import {Router} from "@angular/router";
import {
    LocalisationOutletSelectionComponent
} from "../localisation-outlet-selection/localisation-outlet-selection.component";
import {FUIModalsService} from "@fedeltapointofsale/ui";
import {Subscription} from "rxjs";


@Component({
    selector: "wbo-localisation-modal",
    styleUrls: ["./localisation-modal.component.scss"],
    templateUrl: "./localisation-modal.component.html",
    providers: [provideSearchModel(GroupedOutletCustomSearchModel)]
})
export class LocalisationModalComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() showRestricted: boolean;

    @Output() confirm: EventEmitter<any> = new EventEmitter();

    @ViewChild(LocalisationOutletSelectionComponent) outletSelectionPanel: LocalisationOutletSelectionComponent;

    state: boolean;

    selectedOutlets:  Array<number>;
    selectedCustomObjects:  Array<number>;
    universal: boolean;

    subscriptions: Subscription = new Subscription();

    constructor(public searchModel: GroupedOutletCustomSearchModel,
                private modalsService: FUIModalsService,
                private authService: AuthService,
                private router: Router,
                private changeDetectorRef: ChangeDetectorRef) {
        this.subscriptions.add(router.events.subscribe(() => {
            this.cancelLocalisation();
        }));
    }

    ngOnInit(): void {
        this.searchModel.filter["nonRestriction"] = "true";
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Open the localisation dialog
     * @param selectedOutlets
     * @param selectedCustomObjects
     */
    opened(selectedOutlets: Array<number>, selectedCustomObjects: Array<number>, universal: boolean = false): void {
        this.searchModel.search();
        this.selectedOutlets = selectedOutlets ? Array.from(selectedOutlets) : [];
        this.selectedCustomObjects = selectedCustomObjects ? Array.from(selectedCustomObjects) : [];
        this.universal = universal;
    }

    /**
     *
     */
    cancelLocalisation(): void {
        this.modalsService.close(this);
    }

    /**
     *
     */
    confirmLocalisation(): void {
        this.modalsService.close(this);
        this.confirm.emit();
    }

    clear(): void {
        this.authService.clearRestrictedLocalisation();
        this.modalsService.close(this);
        this.router.navigate([""]);
    }

    get restricted(): boolean {
        return !this.universal;
    }

    set restricted(restricted: boolean) {
        this.universal = !restricted;
    }

    ngAfterViewInit(): void {
        this.changeDetectorRef.detectChanges();
    }
}
